var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"base-popup","title":_vm.title},on:{"ok":_vm.test,"hidden":function($event){return _vm.$bvModal.hide('base=popup')}}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }